import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logOut } from "../Auth/operations";
import { addNewTask, deleteUserTask, editTaskUser, getAllTasks } from "./operators";

interface loadingTask {
  isLoading: boolean;
}

const handlePending = (state: loadingTask) => {
  state.isLoading = true;
};

export interface Task {
  _id: string;
  name: string;
  description: string;
  date: string;
  time: string;
  hours: string;
  id?: string;
}

interface TasksState {
  isLoading: boolean;
  error: string | null;
  tasksUser: Task[];
}

const initialState: TasksState = {
  tasksUser: [],
  isLoading: false,
  error: null,
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTasks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        getAllTasks.fulfilled,
        (state, action: PayloadAction<Task[]>) => {
          state.isLoading = false;
          state.error = null;
          state.tasksUser = action.payload;
        },
      )
      .addCase(addNewTask.pending, handlePending)
      .addCase(addNewTask.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.tasksUser.push(action.payload);
      })
      .addCase(editTaskUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.tasksUser = state.tasksUser.map((task) =>
          task._id === action.payload._id ? action.payload : task,
        );
      })
      .addCase(getAllTasks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteUserTask.pending, handlePending)
      .addCase(deleteUserTask.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.tasksUser = state.tasksUser.filter(
          (task) => task._id !== action.payload.deletedTask._id,
        );
      })
      .addCase(logOut.fulfilled, (state) => {
        state.tasksUser = [];
        state.error = null;
        state.isLoading = false;
      });
  },
});

export const tasksReducer = tasksSlice.reducer;
